/**
 * MenuPreviewCtrl controller
 *
 * @class MenuPreviewCtrl
 * @memberof mwApp/promotion
 * @see mwApp/promotion
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/promotion.controller:MenuPreviewCtrl
 */
/* @ngInject */
export default function MenuPreviewCtrl ($scope, scope) {
  const vm = this

  vm.platform = scope.platform

  vm.previewTabs = {
    stb: {
      aspectRatio: 1.7756
    },
    laptop: {
      aspectRatio: 1.7756
    },
    tablet: {
      aspectRatio: 1.43
    },
    mobile: {
      aspectRatio: 0.53
    }
  }

  vm.samplerNotifications = ['search']

  $scope.$watch(function () {
    return scope.platform
  }, () => {
    vm.platform = scope.platform
    vm.tabConfig = vm.previewTabs[scope.platform]
  })

  $scope.$watch(function () {
    return scope.menu
  }, () => {
    vm.menu = scope.menu
  })
}
